import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const DIFFERENZE = [
  {
    t: "Filtro per patente e cilindrata",
    d: "Chi noleggia una moto deve avere la patente giusta per la cilindrata del mezzo (A1, A2, A). Un catalogo pensato per il noleggio moto deve permettere al cliente di filtrare per queste categorie, cosa che un catalogo pensato solo per auto non prevede.",
  },
  {
    t: "Dotazioni di sicurezza da includere nel contratto",
    d: "Caschi, guanti, eventuale giacca protettiva: vanno elencati nel contratto come dotazione fornita o richiesta al cliente, con relativa responsabilità in caso di mancato utilizzo. È una voce che un contratto pensato solo per auto semplicemente non contempla.",
  },
  {
    t: "Stagionalità più marcata",
    d: "Il noleggio moto, soprattutto per turismo, è molto più concentrato nei mesi caldi rispetto al noleggio auto. Un calendario disponibilità che gestisce bene i picchi stagionali (blocco veicoli in manutenzione tra un noleggio e l'altro, gestione lista d'attesa) conta di più qui che nel noleggio auto.",
  },
  {
    t: "Cauzioni proporzionalmente più alte",
    d: "Il rischio di danno per incidente è mediamente più alto su una moto che su un'auto, e le compagnie assicurative lo riflettono nelle condizioni di noleggio. Molti autonoleggi misti applicano percentuali di cauzione diverse tra le due categorie di veicoli: un gestionale che gestisce cauzioni per categoria evita di doverlo fare a mano ogni volta.",
  },
  {
    t: "Manutenzione più frequente",
    d: "Catene, pastiglie, pneumatici su una moto si consumano più in fretta rispetto a un'auto a parità di chilometraggio. Serve poter bloccare rapidamente un veicolo per manutenzione senza che resti visibile come disponibile sul sito di prenotazione.",
  },
];

const BC_ITEMS = [{ name: "Gestionale per il noleggio moto", path: "/gestionale-noleggio-moto" }];

export default function GestionaleNoleggioMoto({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["gestionale-noleggio-moto"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Guida</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Gestionale per <mark>noleggio moto</mark>: cosa cambia rispetto alle auto
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            Molti gestionali sono pensati prima per le auto e adattati dopo
            alle moto. Ecco dove si vede la differenza.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 820 }}>
          <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: "2rem" }}>
            Se noleggi anche o solo moto e scooter, alcuni requisiti operativi
            non coincidono con quelli di un autonoleggio puro. Questi sono i
            punti dove un gestionale generico mostra i limiti.
          </p>

          {DIFFERENZE.map((d) => (
            <div key={d.t} className="an" style={{ marginBottom: "1.75rem" }}>
              <h2 style={{ fontSize: "1.15rem", marginBottom: ".4rem" }}>{d.t}</h2>
              <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75 }}>{d.d}</p>
            </div>
          ))}

          <div className="an" style={{ marginTop: "2.5rem", padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Auto e moto, cataloghi separati
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              NoleggioinCloud gestisce auto e moto come cataloghi distinti
              sullo stesso sito di prenotazione: categorie, prezzi giornalieri
              e disponibilità separati, così un cliente che cerca uno scooter
              non si trova in mezzo alle auto e viceversa.
            </p>
            <Link to="/funzionalita" style={{ fontWeight: 600 }}>
              Vedi tutte le funzionalità →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "gestionale-noleggio-moto").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
